import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FolderInterface } from 'app/models/folder.model';
import { RequestService } from 'app/modules/common/utils/request.service';
import { Observable } from 'rxjs';
import { FolderDataTransformPost } from './data-transforms/folder.data.transform.post';
import { FolderDataTransformGet } from './data-transforms/folder.data.transform.get';

@Injectable({
  providedIn: 'root',
})
export class FolderHttpInterceptor implements HttpInterceptor {
  private readonly _rexp = new RegExp(/^\/folders(\/[0-9a-z]{24})?$/);

  constructor(
    private readonly _transformDown: FolderDataTransformPost,
    private readonly _transformUp: FolderDataTransformGet,
  ) {}

  intercept(req: HttpRequest<FolderInterface>, next: HttpHandler): Observable<HttpEvent<FolderInterface>> {
    return RequestService.getTransformedHttpEvent<FolderInterface>(
      req,
      next,
      this._rexp,
      this._transformDown,
      this._transformUp,
    );
  }
}
